import * as React from 'react';

const GuestListGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h144v144H0z" />
            <path
                fill="#F6682F"
                fillRule="nonzero"
                d="M36.1 120.3h71.1V30.5H36.1z"
            />
            <path
                fill="#F8FAFF"
                fillRule="nonzero"
                d="M93.2 35.7h4.6v73.8H45.6V35.7h4.6"
            />
            <path
                stroke="#363A43"
                strokeWidth={1.95}
                d="M93.2 35.7h4.6v73.8H45.6V35.7h4.6"
            />
            <path
                stroke="#363A43"
                strokeWidth={1.95}
                d="M36.1 120.3h71.1V30.5H36.1z"
            />
            <path
                fill="#D2D6DF"
                fillRule="nonzero"
                d="M54.9 38.5h33.5V23.8H54.9z"
            />
            <path
                stroke="#363A43"
                strokeWidth={1.95}
                d="M54.9 38.5h33.5V23.8H54.9z"
            />
            <path
                stroke="#363A43"
                strokeWidth={1.95}
                d="M93.2 35.8h4.6v73.8H45.5V35.8h4.6M58.9 30.5H83"
            />
            <g stroke="#363A43" strokeWidth={2.6}>
                <path d="M74.7 66.1l11.7 5.2v3.9c0 2.1-1.3 3.9-2.6 3.9h-26c-1.3 0-2.6-1.7-2.6-3.9v-3.9l11.7-5.2" />
                <path d="M77.3 57.6c0 4.5-2.5 9.7-6.5 9.7-3.9 0-6.5-5.2-6.5-9.7 0-4.5 1.3-7.1 6.5-7.1s6.5 2.6 6.5 7.1zM54.5 87.7h32.6m-32.6 5.9h32.6m-32.6 5.9h17.8" />
            </g>
        </g>
    </svg>
);

GuestListGraphicSvg.displayName = 'GuestListGraphicSvg';
export default GuestListGraphicSvg;
